import urlBuilder from "@Utils/urlBuilder";
import getQueryParams from "helpers/getQueryParams";

/* eslint-disable import/prefer-default-export */
export const getWhiteLabelSearchRedirectionURL = (
  whitelabelConfig: any,
  whitelabel_region_canonical_name: string,
  isDemoSubdomain: boolean,
  partner_uuid: string,
  housingType?: string,
) => {
  let redirectionURL = `/places/search/${whitelabel_region_canonical_name}`;
  if (whitelabelConfig?.listing) {
    const {
      listing: { listing_preferences, distance },
    } = whitelabelConfig;
    const [sort_key, sort_order] = listing_preferences.split(",");

    if (sort_key !== "relevance_sorting_v2") {
      redirectionURL = urlBuilder(redirectionURL, {
        params: {
          sort_key,
          sort_order,
        },
      });
    }

    if (distance !== "20000") {
      redirectionURL = urlBuilder(redirectionURL, {
        params: {
          region_radius: distance,
        },
      });
    }
  }
  if (housingType) {
    redirectionURL = urlBuilder(redirectionURL, {
      params: {
        housing_type: housingType,
      },
    });
  }
  if (isDemoSubdomain) {
    redirectionURL = urlBuilder(redirectionURL, {
      params: {
        partner_id: partner_uuid,
      },
    });
  }
  return redirectionURL;
};

export const getWhiteLabelHomeRedirectionURL = (isDemoSubdomain: boolean, partner_uuid: string) => {
  let redirectionURL = `/`;

  if (isDemoSubdomain) {
    redirectionURL += `?partner_id=${partner_uuid}`;
  }

  return redirectionURL;
};

export const convertToWhitelabelURL = (
  redirectionURL: string,
  isDemoSubdomain: boolean,
  partner_uuid: string,
) => {
  if (!partner_uuid) {
    partner_uuid = getQueryParams().partner_id;
  }
  let redirectionURLConverted = redirectionURL;
  if (isDemoSubdomain) {
    // donotAddLang = true: callers (e.g. PaymentCheckoutButton) navigate via
    // history.push which already goes through languageRouterMiddleware to add
    // the language prefix.  Letting urlBuilder add it here as well causes a
    // double prefix (/fr/payments/fr/complete) → 500 on non-English locales.
    redirectionURLConverted = urlBuilder(
      redirectionURLConverted,
      {
        params: {
          partner_id: partner_uuid,
        },
      },
      true,
    );
  }
  return redirectionURLConverted;
};

export const convertCompleteUrlToWhitelabelUrl = (
  url: string,
  isDemoSubdomain: boolean,
  partner_uuid: string,
  isDesktop = false,
) => {
  const urlObj = new URL(url);
  const hostParts = urlObj.host.split(".");

  if (__DEV__ && isDemoSubdomain) {
    if (hostParts.length >= 1) {
      hostParts.unshift("whitelabel");
      urlObj.host = hostParts.join(".");
    }

    if (isDesktop && urlObj.port === "3000") {
      urlObj.port = "3002";
    }
  } else if (!__DEV__ && typeof window !== "undefined") {
    urlObj.host = window?.location?.host;
  }

  urlObj.searchParams.set("partner_id", partner_uuid);
  return urlObj.toString();
};
